export const loadSessionList = (key) => {
  try {
    const raw = window.sessionStorage.getItem(key);
    if (raw === null) return null;

    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return null;

    return parsed;
  } catch (e) {
    console.error("Erreur lors du chargement du filtre en session:", e);
    return null;
  }
};

export const saveSessionList = (key, list) => {
  try {
    const serialized = JSON.stringify(list);
    window.sessionStorage.setItem(key, serialized);
  } catch (e) {
    console.error("Erreur lors de la sauvegarde du filtre en session:", e);
  }
};
